// src/shared/state.js — ЖИВОТО състояние на приложението (Фаза 3.3).
//
// До 3.3 този файл беше мост към window.CRM (app.js). Сега app.js е мъртъв и
// състоянието живее ТУК. Интерфейсът е същият — 13-те екранни модула не се
// промениха с нито един ред при смяната на собственика.

import { el } from './dom.js';

const _state = {
  user: null,
  companies: [],
  // Обвито като sidebarMode: modal.js вече чете правата оттук, а модалът се
  // отваря и там, където хранилището липсва или хвърля (частен прозорец,
  // тестове без браузър) — тогава просто няма запомнена фирма.
  activeCompany: (function () {
    try { return Number(localStorage.getItem('activeCompany')) || null; }
    catch (e) { return null; }
  })(),
  view: 'dashboard',
  sidebarOpen: false,
  // Менюто на широк екран има три състояния: пълно, само икони, скрито.
  // Помни се, за да не се връща към пълното при всяко отваряне.
  sidebarMode: (function () {
    try { const v = localStorage.getItem('sidebarMode'); return ['full', 'icons', 'hidden'].indexOf(v) >= 0 ? v : 'full'; }
    catch (e) { return 'full'; }
  })(),
};

// Кешове, споделени между екраните (контакти се четат от фактури/проформи и т.н.).
let _contacts = [];
let _invoices = [];
let _proformas = [];

export function state() { return _state; }
export function activeCompanyObj() { return _state.companies.find((c) => c.id === _state.activeCompany) || null; }

// Фактурниците на фирмата (серии номера). Поне един по подразбиране.
export function companyBooks(c) {
  let books = (c && Array.isArray(c.invoice_books)) ? c.invoice_books : [];
  books = books.map((b) => ({ name: (b && b.name) ? String(b.name) : 'Фактурник', start: parseInt(String((b && b.start) || '').replace(/\D/g, ''), 10) || 0 })).filter((b) => b.start > 0);
  if (!books.length) {
    const prefix = String((c && c.invoice_prefix) || '').replace(/\D/g, '');
    const start = prefix ? (parseInt(prefix + '1'.padStart(Math.max(1, 10 - prefix.length), '0'), 10) || 1) : 1;
    books = [{ name: 'Основен', start }];
  }
  return books.sort((a, b) => a.start - b.start);
}

// Избор на ДДС ставка спрямо закона (20% стандартна, 9% намалена, 0%/без ДДС).
export function vatRateSelect(current) {
  const cur = (current != null && current !== '') ? Number(current) : 20;
  const opts = [
    { v: 20, t: '20% — стандартна ставка' },
    { v: 9, t: '9% — намалена ставка (настаняване)' },
    { v: 0, t: '0% — нулева ставка / без начислен ДДС' },
  ];
  if (!opts.some((o) => o.v === cur)) opts.push({ v: cur, t: cur + '% (друга)' });
  return el('select', {}, ...opts.map((o) => el('option', { value: o.v, text: o.t, selected: o.v === cur })));
}

// „Само преглед" по раздел (грешка от картата, 16.10.2026: правото
// съществуваше в сървъра, но не можеше да се зададе от екрана). Правото
// „invoices.read" без „invoices"/„invoices.edit" = разделът се вижда, но не
// се променя. Проформи, артикули и „Изпратени" са под правото „Фактури".
// „Качи от телефона" (ПРОМТ-37) е част от „Доставки" — същото право.
const PERM_OF_VIEW = { proformas: 'invoices', articles: 'invoices', emaillog: 'invoices', phoneupload: 'purchases' };
const PERM_MODULES = new Set(['contacts', 'deals', 'tasks', 'notes', 'invoices', 'protocols', 'checklist', 'vehicles', 'dossiers', 'warehouse', 'purchases', 'zaplati']);
export function permOfView(view) { return PERM_OF_VIEW[view] || view; }
export function isReadOnlyView(view) {
  const u = _state.user;
  if (!u || u.role === 'admin') return false;
  const m = permOfView(view || _state.view);
  if (!PERM_MODULES.has(m)) return false;
  const perms = Array.isArray(u.permissions) ? u.permissions : [];
  return !perms.includes(m) && !perms.includes(m + '.edit') && perms.includes(m + '.read');
}

// Може ли потребителят да ЗАПИСВА в раздела (пълен достъп): админ — винаги;
// иначе голото право ('dossiers') или изричното '.edit'.
export function canEditPerm(module) {
  const u = _state.user;
  if (!u) return false;
  if (u.role === 'admin') return true;
  const perms = Array.isArray(u.permissions) ? u.permissions : [];
  return perms.includes(module) || perms.includes(module + '.edit');
}

// „Изтрий" на повечето записи е само за администратор (сървърът пуска
// само него) — бутонът не се показва на другите (грешка от картата: „Изтрий"
// се виждаше на всички, а сървърът отказваше).
export function isAdminUser() { return !!(_state.user && _state.user.role === 'admin'); }
export function cq() { return _state.activeCompany ? '?company_id=' + _state.activeCompany : ''; }

export function contacts() { return _contacts; }
export function setContacts(v) { _contacts = v; }
export function invoicesCache() { return _invoices; }
export function setInvoices(v) { _invoices = v; }
export function proformasCache() { return _proformas; }
export function setProformas(v) { _proformas = v; }
